import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ICheckBuilder from "../../../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

type Inputs = "ignorarCaducidad" | "razonIgnorarCaducidad";
type Buttons = "aceptar" | "cancelar";

export const caducidadFormConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "ignorarCaducidad",
      label: "Omitir validación de caducidad",
      bts: {
        xCol: 12
      },
      component: ICheckBuilder
    },
    {
      name: "razonIgnorarCaducidad",
      label: "Razón para omitir la validación",
      bts: {
        xCol: 12
      },
      component: ITextBuilder,
      props: {
        hidden: (values: any) => !values.ignorarCaducidad
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: {
        mCol: 3,
        mOff: 6
      },
      component: IButtonBuilder
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    razonIgnorarCaducidad: {
      requiredIfIgnorarCaducidad: {
        validator: (value, formValue) => formValue.ignorarCaducidad && !value,
        message: () => "Campo obligatorio"
      },
      minLengthIfIgnorarCaducidad: {
        validator: (value, formValue) =>
          formValue.ignorarCaducidad && value && value.trim().length < 10,
        message: () => "Ingrese al menos 10 caracteres"
      }
    }
  },
  rows: [
    ["ignorarCaducidad"],
    ["razonIgnorarCaducidad"],
    ["aceptar", "cancelar"]
  ]
};
